import React from 'react'
import PropTypes from 'prop-types'
import { LinkButton } from '../link-button'

export function SidebarLink (props) {
  return <LinkButton {...props} className='nav-link d-flex'>{props.children}</LinkButton>
}

SidebarLink.propTypes = {
  to: PropTypes.string.isRequired,
  anchor: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  url: PropTypes.object
}
